/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import union from 'lodash/union';
import isNil from 'lodash/isNil';
import {
  API_PENDING,
  API_SUCCESS,
  API_FAILURE,
} from 'loraactions/api';
import { types } from 'loraactions/usage';


const typeKeys = {
  [types.apps]: 'apps',
  [types.gateways]: 'gateways',
  [types.nodes]: 'nodes',
};

// state schema:
// {
//   apps?: number,
//   gateways?: number,
//   nodes?: number,
//   pendings: ['apps' | 'gateways' | 'nodes' ...]
//   errors: {
//     apps?: error,
//     gateways?: error,
//     nodes?: error,
//   }
// }
export default (state = {}, action) => {
  const { type, meta: { api } = {} } = action;
  const key = typeKeys[type];

  if (isNil(key)) {
    return state;
  }

  if (!api) {
    return state;
  }

  if (api.status === API_SUCCESS) {
    const { pendings = [], ...rest } = state;
    return {
      ...rest,
      [key]: api.response.count,
      pendings: pendings.filter(k => k !== key),
    };
  } else if (api.status === API_PENDING) {
    const { pendings = [], ...rest } = state;
    return {
      ...rest,
      pendings: union(pendings, [key]),
    };
  } else if (api.status === API_FAILURE) {
    const { errors = {}, ...rest } = state;
    return {
      ...rest,
      errors: { ...errors, key: api.error },
    };
  }
  return state;
};




// WEBPACK FOOTER //
// ./src/redux/reducers/usage.js